import React from 'react'
import { useHistory } from 'react-router-dom'

import LoadingButton from "../components/LoadingButton"
import LOGO from "../components/Logo"

import { useActions } from "../redux_utils"
import Urls from '../../UrlConfig'

export default () => {

	/**
	 * Parent :
	 *      AuthPage
	 * 
	 */
	const history = useHistory()

	const logoutUser = useActions(() => ({ type: 'USER_LOGOUT' }))
	// logout user and redirect to login page
	const logoutRedirect = () => {
		logoutUser()
		history.push(Urls.getAuthPage('login'))
	}
	
	return (
		<div className="auth-wrapper">
			<div className="auth-fixed-bg">
				{/* <img src={BLUR_BG} /> */}
			</div>    
			<div className="auth-body-wrapper">
				<div className="auth-card">
					
					<LOGO />
					{/* <div className="placeholder-img">
						<img src={CHECK_ICON} className="responsive-img" alt=""/>
					</div> */}
					<div className="form-content-margin">
						<div className="title accent-text bold">Page Not Found</div>
						<div className="sub-title accent-text">Sorry! we can't seem to find the page you were looking for. Please visit the Home Page</div>

						<div className="btn-wrapper" style={{ paddingTop: '5rem'}}>
							<LoadingButton 
								className="btn primary-btn"
								onClick={() => history.push('/')}
								label="Go To Home"
								loading={false}
							/>
						</div>
						<div className="btn-wrapper" style={{ paddingBottom : '8rem'}}>
							<LoadingButton 
								className="btn primary-btn"
								onClick={logoutRedirect}
								label="Logout"
								loading={false}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}